var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center" }, [
      _c("h4", [
        _c("i", { staticClass: "fas fa-spinner fa-spin" }),
        _vm._v(" Регистрация пользователя..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }